import React from 'react'
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown'
import { ChevronDown } from 'react-feather'

const DateFilter = ({className, placeholder, /* onChange, type */}) => {
  return (
    <React.Fragment>
      <Dropdown className="w-full">
        <DropdownTrigger>
          <div
            className={`rounded border p-2 w-full bg-white text-sm cursor-pointer flex justify-between items center ${className}`}
            style={{borderColor: 'hsl(0,0%,80%)', color: '#808080'}}
          >
            <div>{placeholder ? placeholder : 'Date'}</div>
            <div><ChevronDown style={{width: '20px', height: '20px', color: 'hsl(0,0%,80%)'}}/></div>
          </div>
        </DropdownTrigger>
        <DropdownContent className="no-tip">
          <div>
            <div className="text-sm p-4 font-primary normal-case font-normal border-b text-gray-444" style={{borderColor: '#eee'}}>
              <div className="mb-2">
                <input type="checkbox" className="mr-2" id="past"/>
                <label htmlFor="past">Past 30 Days</label>
              </div>
              <div className="mb-2">
                <input type="checkbox" className="mr-2" id="2019"/>
                <label htmlFor="2019">2019</label>
              </div>
              <div className="mb-2">
                <input type="checkbox" className="mr-2" id="2020"/>
                <label htmlFor="2020">2020</label>
              </div>
            </div>

            <div className="text-gray-444 text-sm p-4 font-primary normal-case font-normal">
              <div className="mb-4">
                <label htmlFor="from" className="mb-1">From</label>
                <input type="date" className={`rounded border py-2 px-4 w-full bg-white text-sm cursor-pointer ${className}`} id="from"/>
              </div>
              <div className="mb-4">
                <label htmlFor="to" className="mb-1">To</label>
                <input type="date" className={`rounded border py-2 px-4 w-full bg-white text-sm cursor-pointer ${className}`} id="to"/>
              </div>
              <button className="w-full border rounded text-primary text-center p-3" style={{borderColor: '#52BAE2'}}>
                Submit
              </button>
            </div>
          </div>
        </DropdownContent>
      </Dropdown>
    </React.Fragment>
  )
}

export { DateFilter }